import { render, staticRenderFns } from "./DeliverDetail.vue?vue&type=template&id=344b7746&scoped=true"
import script from "./DeliverDetail.vue?vue&type=script&lang=js"
export * from "./DeliverDetail.vue?vue&type=script&lang=js"
import style0 from "./DeliverDetail.vue?vue&type=style&index=0&id=344b7746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344b7746",
  null
  
)

export default component.exports